
export const GET_CUSTOMER_REPORT_FAIL = 'GET_CUSTOMER_REPORT_FAIL';
export const GET_CUSTOMER_REPORT_REQUEST='GET_CUSTOMER_REPORT_REQUEST';
export const GET_CUSTOMER_REPORT_SUCCESS = 'GET_CUSTOMER_REPORT_SUCCESS';

export const GET_CALLING_REPORT_FAIL = 'GET_CALLING_REPORT_FAIL';
export const GET_CALLING_REPORT_REQUEST='GET_CALLING_REPORT_REQUEST';
export const GET_CALLING_REPORT_SUCCESS = 'GET_CALLING_REPORT_SUCCESS';
